import { SortOrder } from 'components/molecule/table/RenderTable';
import { addFilterField } from 'utils/helper/helper';

export const timeColumn = 'created_at';
export const defaultSort = {
  column: timeColumn,
  order: SortOrder.DESC,
};

export const filters = ({ values }) => ({
  ...addFilterField('filter[bin_cont]', values.bin),
  ...addFilterField('filter[card_brand_cont]', values.card_brand),
  ...addFilterField('filter[card_type_cont]', values.card_type),
  ...addFilterField('filter[card_sub_type_cont]', values.card_sub_type),
  ...addFilterField('filter[issuing_organisation_cont]', values.issuing_organisation),
  ...addFilterField('filter[country_cont]', values.country),
  ...addFilterField('filter[iso2_cont]', values.iso2),
  ...addFilterField('filter[iso3_cont]', values.iso3),
  ...addFilterField('filter[iso_numeric_eq]', values.iso_numeric),
});
